import {
    AnimationBaseController,
    GameRandom,
    IAnimationControllerConfiguration,
    Inject
} from "@denishussar/html5-game-engine";
import {ElectricityLogic} from "../Logic/ElectricityLogic";
import {SwitchModel, SwitchStateEnum} from "../Models/SwitchModel";

export interface ISwitchControllerOptions {
}

export class SwitchController extends AnimationBaseController {

    $model: SwitchModel;

    public constructor(@Inject private _options: ISwitchControllerOptions,
                       @Inject private _gameLogic: ElectricityLogic) {
        super("SwitchAnimationController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            childControllers: {},
            modelWatch: {
                "state": (newValue: SwitchStateEnum, oldValue: SwitchStateEnum) => {

                    if(newValue === SwitchStateEnum.off) {

                        this.display.interactive = false;
                        this.$queue.get("off").addToQueue(this.$model.index);

                    } else if(newValue === SwitchStateEnum.on) {

                        this.gotoAndStop(`${SwitchStateEnum[this.$model.state]}`);

                    } else if(newValue === SwitchStateEnum.off_immediately) {

                        this.gotoAndStop("off");

                    } else {

                        this.display.interactive = false;
                    }
                }
            },
            modelEvents: {},
            queue: {
                "off": {
                    condition: clock => clock > 0.2,
                    action: () => {
                        this.gotoAndStop(`${SwitchStateEnum[this.$model.state]}`);
                        this.display.interactive = true;
                    }
                },
            },
            onPointerDown: (e) => {
                this._gameLogic.clickOnSwitch(this.$model);
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(`${SwitchStateEnum[this.$model.state]}`);
        this.display.interactive = true;
        this.display.buttonMode = true;
    }

    protected onAnimationEvent(name: string, ...args): void {}
}
